import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseCheckPollingDto } from '../gd-only/dto/poling.dto';
import { NestApiProvider } from '../nest-api';
import { responseObj } from '../nest-model/nest-model';

/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PollingSf6Provider {

  module: string = 'polling';
  model: string = 'sf6s/polling';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello polling Provider');
  }

  getPolling(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "getPolling";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';


    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  getPollingDetail(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "getPollingDetail";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  add(formData: Object) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  public checkPolling(): Observable<responseObj<ResponseCheckPollingDto>> {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "checkPeriodic";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<ResponseCheckPollingDto>>(method, url, params, urlParams, body, contentType);
  }

  public checkPollingList(): Observable<responseObj<ResponseCheckPollingDto>> {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "checkPeriodicList";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<ResponseCheckPollingDto>>(method, url, params, urlParams, body, contentType);
  }

  public addPeriodic(formData: Object) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "savePeriodic";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/polling/polling-sf6.ts